import { ImageLayout } from '~/singlePageApp/screens/AnonymousMedia/layouts/ImageLayout';
import type { JSX } from 'react';
import type { AnonymousMediaQuery } from '../__gql/AnonymousMedia.gql.gen';

type UnsupportedMediaTypeLayoutProps = {
  media: NonNullable<AnonymousMediaQuery['anonymousMedia']>;
};

export const UnsupportedMediaTypeLayout = ({
  media,
}: UnsupportedMediaTypeLayoutProps): JSX.Element => {
  const unsupportedMediaAsImage = {
    ...media,
    imageUrl: 'https://hypertext.wistia.com/assets/6bbb8757d2c8caef47cc81a7cd6b7fb3.png',
  };

  return (
    <ImageLayout
      imageStyleOverrides={{
        width: '70vh',
      }}
      commentingDisabled={true}
      media={unsupportedMediaAsImage}
    />
  );
};
